import styled from "styled-components";

const StyledStepInativa = styled.div`
  background-color: #5468ff;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center; /* Corrigido aqui */
  font-size: 12px;
  color: #fff;
`;

const StepInativa = ({ label }) => {
  return <StyledStepInativa>{label}</StyledStepInativa>;
};

export default StepInativa;
